/**
 * Local "has-seen-onboarding" flag.
 *
 * Onboarding is shown once. The flag is stored in localStorage so
 * it survives reloads and app restarts. Clearing site data resets
 * the flag — for production the authoritative record lives in
 * `users.onboarding_completed_at` on the server.
 *
 * The server-side flag is the source of truth for "should we show
 * the carousel after the user signs in"; this local flag is the
 * pre-sign-in fallback so the carousel only appears on first
 * launch.
 */
const ONBOARDING_KEY = 'effectiveslp.onboardingSeen';

export function hasSeenOnboarding(): boolean {
  try {
    return localStorage.getItem(ONBOARDING_KEY) === '1';
  } catch {
    // localStorage can throw in privacy modes / SSR / sandboxed
    // iframe contexts. Treat unreadable as "not seen" so the
    // carousel shows.
    return false;
  }
}

export function markOnboardingSeen(): void {
  try {
    localStorage.setItem(ONBOARDING_KEY, '1');
  } catch {
    // best-effort; ignore storage failures
  }
}
